import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-consulta-de-pagos',
  templateUrl: './consulta-de-pagos.component.html',
  styleUrls: ['./consulta-de-pagos.component.scss']
})
export class ConsultaDePagosComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
